import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AutoroutingService } from '../../autorouting.service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-autorouting-settings',
  templateUrl: './autorouting-settings.component.html',
  styleUrls: ['./autorouting-settings.component.scss']
})
export class AutoroutingSettingsComponent implements OnInit {
  public autoroutingSettingsForm: FormGroup;
  public data: any = {};
  private autoroutingSettingRegister = null;
  autoRoutingSettings: string;

  constructor(
    protected fb: FormBuilder,
    private _autoroutingSettingService: AutoroutingService,
    private sweetAlertHelper: SweetAlertHelper
    ) {
    this.createForm();
  }

  ngOnInit() {
    this.loadData();
  }

  createForm() {
    this.autoroutingSettingsForm = this.fb.group( {
      _isBasedOnTimeLegA: [false], // This isn't going to be sent.
      _isBasedOnTimeLegB: [false], // This isn't going to be sent.
      autoroutingsettingid:   null,
      pickupstart:           ['', Validators.required],
      pickupend:            ['', Validators.required],
      dropoffstart:          ['', Validators.required],
      dropoffend:           ['', Validators.required],
      legbpickupstart:           ['', Validators.required],
      legbpickupend:            ['', Validators.required],
      legbdropoffstart:          ['', Validators.required],
      legbdropoffend:           ['', Validators.required],
      keepassignedtrips:      ['', Validators.required],
      usedriveraddress:        ['', Validators.required],
      usedriverzone:        ['', Validators.required],
      onboard1:        ['', Validators.required],
      legbonboard1:        ['', Validators.required],
      speed: ['', Validators.required],
      autoroutingsettingtimes: this.fb.array([
        this.fb.group({
            capacitytypeid: 1,
            time: ['', Validators.required]
          }
        ),
        this.fb.group({
            capacitytypeid: 2,
            time: ['', Validators.required]
          }
        ),
        this.fb.group({
            capacitytypeid: 3,
            time: ['', Validators.required]
          }
        ),
      ]),
    });
  }

  loadForm(data) {
    this.autoroutingSettingsForm.patchValue({
      _isBasedOnTimeLegA:   data.onboard1 === 0 ? true : false, // THIS IS FOR THE UI (Switches)
      _isBasedOnTimeLegB:   data.legbonboard1 === 0 ? true : false, // THIS IS FOR THE UI (Switches)
      autoroutingsettingid:   data.autoroutingsettingid,
      pickupstart:           data.pickupstart,
      pickupend:            data.pickupend,
      dropoffstart:          data.dropoffstart,
      dropoffend:           data.dropoffend,
      legbpickupstart:       data.legbpickupstart,
      legbpickupend:        data.legbpickupend,
      legbdropoffstart:      data.legbdropoffstart,
      legbdropoffend:       data.legbdropoffend,
      keepassignedtrips:      data.keepassignedtrips,
      usedriveraddress:       data.usedriveraddress,
      usedriverzone:        data.usedriverzone,
      speed: data.speed,
      onboard1: data.onboard1,
      legbonboard1:       data.legbonboard1,
      autoroutingsettingtimes: [
        {
          capacitytypeid: data.autoroutingsettingtimes[0].capacitytypeid || null,
          time: data.autoroutingsettingtimes[0].time || null
        },
        {
          capacitytypeid: data.autoroutingsettingtimes[1].capacitytypeid || null,
          time: data.autoroutingsettingtimes[1].time || null
        },
        {
          capacitytypeid: data.autoroutingsettingtimes[2].capacitytypeid || null,
          time: data.autoroutingsettingtimes[2].time || null
        }
      ]
    });
  }

  get arrayForm(): FormArray {
    return this.autoroutingSettingsForm.get('autoroutingsettingtimes') as FormArray;
  }

  loadData() {
    this._autoroutingSettingService.getAutoroutingSetting()
      .subscribe(data => {
        if (data !== null) {
          this.loadForm(data);
          this.autoroutingSettingRegister = data;
          this.autoRoutingSettings = data.version;
        }
      });
  }

  saveAction(data) {
    // Delete unused fields
    delete data._isBasedOnTimeLegA;
    delete data._isBasedOnTimeLegB;

    // Set legbonboard1 to 0 if this.isBasedOnTimeTravel is true
    if (this.isBasedOnTimeTravelA) {
      data.onboard1 = 0;
    } else if (this.isBasedOnTimeTravelB) {
      data.legbonboard1 = 0;
    }

    const prefixSer = this._autoroutingSettingService;
    const service =  (this.autoroutingSettingRegister !== null)
      ? prefixSer.putAutoroutingSetting(data) :
        prefixSer.postAutoroutingSetting(data)
        service.subscribe( resp => {
          this.swalFire(resp);
      });
  }

  swalFire(resp) {
   if (resp.message) {
      const message = this.sweetAlertHelper.createCustomAlert({
        text: resp.message,
        title: 'Success: ' + resp.success,
        type: resp.success ? 'success' : 'info'
      });
      return message;
    } else {
      const message = this.sweetAlertHelper.createCustomAlert({
        title: 'Error with action',
        text: 'Try again later',
        type: 'error'
      });
      return message;
    }
  }

  get isBasedOnTimeTravelA(): boolean {
    return this.autoroutingSettingsForm.get('_isBasedOnTimeLegA').value;
  }

  get isBasedOnTimeTravelB(): boolean {
    return this.autoroutingSettingsForm.get('_isBasedOnTimeLegB').value;
  }

  get isOdlConnect(): boolean {
    return this.autoRoutingSettings === 'ODLConnect';
  }

  get isOdLive(): boolean {
    return this.autoRoutingSettings === 'ODLLive';
  }

  get isGoogle(): boolean {
    return this.autoRoutingSettings === 'Google';
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/autorouting/components/autorouting-settings/autorouting-settings.component.ts